export default {
    kinerja : {
        disposisiTerbaru : [],
        ratingPerbidang : [],
        ratingTerbaru : [],
        kinerja : [],
    },
    statistik : {
        statistikIzin : {
            dalam_proses:0,
            dibatalkan:0,
            ditolak:0,
            permohonan_masuk:0,
            revisi:0,
            selesai:0,

        },
        grafikPermohonan : [],
        grafikPermohonanPerbidang : [],
        grafikPermohonanVerifikasiPerbidang : [],
        grafikPermohonanPerbulan : [],
        grafikPermohonanPerbulanGenap : [],
        grafikPermohonanSelesaiPerbidang : [],
        grafikPermohonanPerminggu : []
    }
}
